import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import ParticlesAuth from "./ParticlesAuth";
import error from "../../assets/images/error.svg";

const Error404 = () => {
document.title ="Página não encontrada | Ad Pulse";
    return (
        <React.Fragment>
                <ParticlesAuth>
                    <div className="auth-page-content mt-lg-5">
                        <Container>
                            <Row>
                                <Col lg={12}>
                                    <div className="text-center pt-4">
                                        <div className="">
                                            <img src={error} alt="" className="error-basic-img move-animation" />
                                        </div>
                                        <div className="mt-n4">
                                            <h1 className="display-1 fw-medium">404</h1>
                                            <h3 className="text-uppercase">Desculpe, página não encontrada 😭</h3>
                                            <p className="text-muted mb-4">A página que você está procurando não está disponível!</p>
                                            <Link to="/" className="btn btn-success"><i className="mdi mdi-home me-1"></i>Voltar para a página inicial</Link>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </ParticlesAuth>
        </React.Fragment>
    );
};

export default Error404;